import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  Flag,
  Grid,
  Label,
} from 'semantic-ui-react';
import clone from 'clone';
import { required, phoneNumber } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import PhoneInput from '../../components/AppForm/PhoneInput';
import INTL_FLAG_CODES from '../../constants/intlFlagCodes';

export default class PersonalInfo extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
  }
  static defaultCustomerData = {
    id: '',
    customerDetailID: '',
    identityTypeID: '',
    identity: '',
    icFrontDocumentID: '',
    icFrontDocument: null,
    icBackDocumentID: '',
    icBackDocument: null,
    incomeID: '',
    customerCreditReports: [],
    customerCreditReport: null,
    runCreditCheck: false,
  }
  static defaultCustomerDetailData = {
    title: '',
    name: '',
    preferredName: '',
    email: '',
    mobilePrefix: '',
    mobile: '',
    phonePrefix: '',
    phone: '',
    address1: '',
    address2: '',
    city: '',
    postcode: '',
    state: '',
    country: '',
  }
  static defaultValues = {
    identityTypeID: null,
    identity: '',
    name: '',
    mobilePrefix: '60',
    mobile: '',
    phonePrefix: '60',
    phone: '',
  }
  static getPropsToState = (props) => {
    const data = Object.assign({}, PersonalInfo.defaultCustomerData, props.data || {});
    if (!data.customerDetailID) {
      data.customerDetail = Object.assign({}, PersonalInfo.defaultCustomerDetailData);
    }
    const dataEditingCustomer = {
      identityTypeID: data.identityTypeID,
      identity: data.identity,
      name: data.customerDetail.name,
      mobilePrefix: data.customerDetail.mobilePrefix,
      mobile: data.customerDetail.mobile,
      phonePrefix: data.customerDetail.phonePrefix,
      phone: data.customerDetail.phone,
    };
    const editingCustomer = Object.assign({}, PersonalInfo.defaultValues, dataEditingCustomer);
    return {
      data,
      oriData: clone(data),
      editingCustomer,
    };
  }
  constructor(props) {
    super(props);
    const state = PersonalInfo.getPropsToState(props);
    this.state = {
      ...state,
      loading: false,
      errMessages: [],
      hasChanges: false,
    };
    this.validation = {
      name: createRef(),
      mobile: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = PersonalInfo.getPropsToState(nextProps);
    if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
      state.editingCustomer = this.state.editingCustomer;
    }
    if (state !== this.state) {
      this.setState({ state });
    }
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  setloading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  submit(url, opts) {
    return this.infoForm.submit(url, opts);
  }
  handleCheckChanges() {
    const { data } = this.state;
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true });
    }
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  }
  handleChange = (event, value) => {
    const { editingCustomer, data } = this.state;
    if (value.name === 'name') {
      data.customerDetail[value.name] = value.value;
    }
    editingCustomer[value.name] = value.value;
    this.setState({ editingCustomer, data }, () => {
      if (value.name === 'mobilePrefix') {
        this.validation.mobile.current.validate(editingCustomer.mobile);
      }
      data.customerDetail[value.name] = value.value;
      this.handleCheckChanges();
    });
  }
  handleSubmit = () => {
    const { data } = this.state;
    AppForm.validate(this.validation, data.customerDetail)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        this.props.onSubmit(validations, data);
      });
  }
  render() {
    const { data, editingCustomer } = this.state;
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.infoForm = ref; }}
      >
        <Grid centered>
          <Grid.Row>
            <Grid.Column computer={7} tablet={9} mobile={16} textAlign="right">
              <Label
                style={{ float: 'left', background: 'transparent', color: 'black' }}
                content={data.identityTypeID === 4 ? 'Company Name' : 'Full Name'}
              />
              <AppForm.Input
                autoComplete="off"
                name="name"
                onChange={this.handleChange}
                placeholder={data.identityTypeID === 4 ? 'Company Name' : 'Full Name'}
                ref={this.validation.name}
                validation={[required]}
                value={editingCustomer.name}
                validateLabel={data.identityTypeID === 4 ? 'Company Name' : 'Full Name'}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column computer={7} tablet={9} mobile={16}>
              <Label
                style={{ float: 'left', background: 'transparent', color: 'black' }}
                content="NRIC"
              />
              <AppForm.Input
                disabled
                name="identity"
                placeholder="eg: 890909-05-1234"
                value={data.identity}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingBottom: '0' }}>
            <Grid.Column computer={7} tablet={9} mobile={16}>
              <Label
                style={{ float: 'left', background: 'transparent', color: 'black' }}
                content="Phone"
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row style={{ paddingTop: '0' }}>
            <Grid.Column computer={2} tablet={3} mobile={7} style={{ paddingRight: '0' }}>
              <AppForm.Validate
                validation={[required]}
                onChange={this.handleChange}
                validationLabel="Mobile prefix"
              >
                <Dropdown
                  fluid
                  value={editingCustomer.mobilePrefix}
                  selectOnBlur={false}
                  trigger={
                    <p style={{ margin: 0, display: 'inline-block', width: '70%', textAlign: 'center', paddingLeft: '0.2rem' }}>
                      <Flag name={INTL_FLAG_CODES.find(({ value: v }) => v === editingCustomer.mobilePrefix).countryCode} style={{ paddingRight: '1.5rem' }} />
                      ({editingCustomer.mobilePrefix})
                    </p>
                  }
                  style={{ padding: '0.6em', border: '1px solid rgba(34,36,38,.15)', borderBottomLeftRadius: '0.3rem', borderTopLeftRadius: '0.3rem', marginTop: '0.28571429rem' }}
                >
                  <Dropdown.Menu style={{ overflowY: 'scroll', height: '10rem' }}>
                    {INTL_FLAG_CODES.map(({ value, text, countryCode }) => (
                      <Dropdown.Item
                        name="mobilePrefix"
                        key={`${value}_${text}`}
                        value={value}
                        onClick={this.handleChange}
                      >
                        <Flag name={countryCode} /> {text}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </AppForm.Validate>
            </Grid.Column>
            <Grid.Column computer={5} tablet={6} mobile={9} style={{ paddingLeft: '0' }} textAlign="right">
              <PhoneInput
                autoComplete="off"
                name="mobile"
                onChange={this.handleChange}
                placeholder={editingCustomer.mobilePrefix === '60' ? 'Mobile* (e.g. 196756118)' : 'Mobile*'}
                ref={this.validation.mobile}
                type="tel"
                validation={[required, {
                  validate: phoneNumber,
                  option: editingCustomer.mobilePrefix === 'other' ? {} : {
                    isMobile: true,
                    phonePrefix: editingCustomer.mobilePrefix,
                  },
                }]}
                value={editingCustomer.mobile}
                validateLabel="Mobile"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/PersonalInfo.jsx